/**
 * video-breakpoint-loader.js
 *
 * Perf fix (audit mobile 2026-08-12) : les vidéos de fond desktop/mobile sont posées
 * par snippets/video.liquid dans un <template data-video-breakpoint="desktop|mobile">
 * plutôt que directement dans la page. Le contenu d'un <template> est inerte : le
 * navigateur ne télécharge RIEN de ce qu'il contient tant qu'il n'a pas été cloné dans
 * le document. Ce script clone uniquement le <template> qui correspond à l'appareil du
 * visiteur, et retire l'autre — qui ne sera donc jamais téléchargé.
 *
 * Avant ce correctif, un visiteur mobile pouvait télécharger à la fois la vidéo
 * "desktop" et la vidéo "mobile" (le CSS masquait l'une des deux à l'écran, mais ne
 * l'empêchait pas d'être chargée), ce qui pouvait représenter plusieurs Mo inutiles.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 719px)';

  function loadMatchingVideos() {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;

    document.querySelectorAll('template[data-video-breakpoint]').forEach(function (template) {
      var breakpoint = template.getAttribute('data-video-breakpoint');
      var matchesDevice =
        (breakpoint === 'mobile' && isMobile) || (breakpoint === 'desktop' && !isMobile);

      if (!matchesDevice) {
        // Mauvais breakpoint pour cet appareil : on retire le template sans jamais
        // avoir déclenché le téléchargement de la vidéo qu'il contient.
        template.remove();
        return;
      }

      var wrapper = template.closest('.video-wrapper');
      var fragment = template.content.cloneNode(true);
      template.replaceWith(fragment);

      if (!wrapper) return;

      var video = wrapper.querySelector('video');
      if (!video) return;

      // La vidéo prend le relais du poster statique : on retire ce dernier pour éviter
      // qu'il ne reste affiché en double (empilé au-dessus/en dessous de la vidéo).
      var poster = wrapper.querySelector('.js-video-poster');
      if (poster) poster.remove();

      // autoplay est déjà présent sur la balise ; ce play() est une sécurité pour les
      // navigateurs qui n'auto-démarrent pas une vidéo insérée dynamiquement après coup.
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // Lecture automatique refusée par le navigateur : cas très rare pour une
          // vidéo muted+playsinline, on laisse alors juste le premier photogramme
          // (poster natif de <video>) affiché à la place.
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadMatchingVideos);
  } else {
    loadMatchingVideos();
  }
})();